import { supabase } from '../supabase/client';
import { useNotificationStore } from '../../stores/notification-store';
import type { RealtimeChannel } from '@supabase/supabase-js';
import type { Tables } from '../supabase/types';

type Notification = Tables<'user_notifications'>;

let notificationChannel: RealtimeChannel | null = null;

export function initializeNotificationsListener(userId: string) {
  if (notificationChannel) {
    return notificationChannel;
  }

  notificationChannel = supabase
    .channel('user_notifications_channel')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'user_notifications',
        filter: `target_user_id=eq.${userId}`,
      },
      (payload) => {
        const notification = payload.new as Notification;
        const store = useNotificationStore.getState();
        
        // Add notification to store
        store.addNotification(notification);

        // Play notification sound if enabled
        if (store.soundEnabled) {
          playNotificationSound();
        }

        // Show browser notification if permitted
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification('Candle Legacy', {
            body: notification.message,
            icon: '/favicon.png',
          });
        }
      }
    )
    .subscribe();

  return notificationChannel;
}

export function cleanupNotificationsListener() {
  if (notificationChannel) {
    notificationChannel.unsubscribe();
    notificationChannel = null;
  }
}

function playNotificationSound() {
  try {
    const audio = new Audio('/notification.mp3');
    audio.volume = 0.5;
    audio.play().catch(() => {
      // Ignore errors (user might not have interacted with page yet)
    });
  } catch (error) {
    // Ignore errors
  }
}
